<ng-progress></ng-progress>

<ng-container *ngIf="bootstrap$ | async as boot">
  <div class="schema-bootstrap-banner"
       *ngIf="boot.status === 'loading'">
    <p>{{'schemaBootstrapLoading' | translate}}</p>
  </div>

  <div class="schema-bootstrap-error"
       *ngIf="boot.status === 'unavailable' || boot.status === 'malformed-schema'"
       role="alert">
    <h1>{{'schemaBootstrapUnavailableTitle' | translate}}</h1>
    <p *ngIf="boot.status === 'unavailable'">
      {{'schemaBootstrapUnavailable' | translate}}
    </p>
    <p *ngIf="boot.status === 'malformed-schema'">
      {{'schemaBootstrapMalformed' | translate}}
    </p>
    <p class="schema-bootstrap-meta" *ngIf="boot.retryCount > 0">
      {{ ('schemaBootstrapRetries' | translate:{ count: boot.retryCount }) }}
    </p>
    <div class="schema-bootstrap-actions">
      <button type="button"
              class="schema-bootstrap-btn"
              [disabled]="boot.inFlight || boot.retryCount >= 3"
              (click)="retry()">
        {{'retry' | translate}}
      </button>
      <button type="button"
              class="schema-bootstrap-btn schema-bootstrap-btn--secondary"
              (click)="logout()">
        {{'logout' | translate}}
      </button>
    </div>
  </div>

  <router-outlet *ngIf="boot.status !== 'unavailable' && boot.status !== 'malformed-schema'"></router-outlet>
</ng-container>
